var bgColor = {
    dark: '#253858',
    error: '#f9e9e8',
    success: '#e5f8eb',
    warning: '#fff7e1',
    info: '#e3f2ff',
    light: '#fff',
};
var textColor = '#00294d';
var colors = {
    dark: {
        textColor: '#fff',
        backgroundColor: bgColor.dark,
        arrowColor: bgColor.dark
    },
    success: {
        textColor: textColor,
        backgroundColor: bgColor.success,
        arrowColor: bgColor.success
    },
    warning: {
        textColor: textColor,
        backgroundColor: bgColor.warning,
        arrowColor: bgColor.warning
    },
    error: {
        textColor: textColor,
        backgroundColor: bgColor.error,
        arrowColor: bgColor.error
    },
    info: {
        textColor: textColor,
        backgroundColor: bgColor.info,
        arrowColor: bgColor.info
    },
    light: {
        textColor: textColor,
        backgroundColor: bgColor.light,
        arrowColor: bgColor.light,
        // borderColor: 'transparent',
    }
};
export { colors };
